import { render, staticRenderFns } from "./howDoWeDoIt.vue?vue&type=template&id=a5ddd40a&scoped=true&"
import script from "./howDoWeDoIt.vue?vue&type=script&lang=js&"
export * from "./howDoWeDoIt.vue?vue&type=script&lang=js&"
import style0 from "./howDoWeDoIt.vue?vue&type=style&index=0&id=a5ddd40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ddd40a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
